<router-outlet></router-outlet>

<ngx-spinner size="default" color="#94D0E8" type="timer" [fullScreen]="true">
  <p style="color: white">{{ 'app_spinner_text' | translate }}</p>
</ngx-spinner>
<p-toast position="top-center"></p-toast>

<!-- <h1>{{ env | json }}</h1> -->
